// @ts-nocheck
import * as React from "react"
import * as AOS from 'aos'

export default ({ articleInfo }: BlogArticles) => {
    
    const insertAfter = (referenceNode, newNode) => {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    const getImageCaption = () => {
        let images = document.querySelectorAll('.detalle__content-body img[data-caption]')
        let captionImage = document.createElement('p')
        captionImage.classList.add('fig-caption')
        if (images.length > 0) {
            for (let i = 0; i < images.length; i++) {
                let cloneCaption = captionImage.cloneNode()
                cloneCaption.textContent = images[i].dataset.caption
                insertAfter(images[i], cloneCaption)
            }
        }
    }

    React.useEffect(() => {
        getImageCaption()
    }, [])

    React.useEffect(() => {
        AOS.init()
    });

    return (
        <div className="blog-detalle">
            <div className="detalle" data-aos="fade-up" data-aos-duration="800">
                <div className="detalle__banner">
                    <img src={articleInfo.field_image.url} alt="" className="detalle__banner-image" />
                </div>
                <div className="detalle__content">
                    <h2 className="title taC" data-aos="fade-up" data-aos-duration="800">{articleInfo.field_titlemain}</h2>
                    <div className="text taC" data-aos="fade-up" data-aos-duration="800" dangerouslySetInnerHTML={{ __html: articleInfo.field_descmain }}></div>

                    <div className="detalle__content-description">
                        <div className="profile">
                            <div className="profile__info hide" data-aos="fade-right" data-aos-duration="800" data-aos-anchor-placement="bottom-bottom">
                                <img src={articleInfo.picture} width="70" height="70" className="profile__info-image" />
                                <div className="profile__info-text">
                                    <p className="name textS">{articleInfo.author}</p>
                                    <p className="textS">{articleInfo.format_date} · {articleInfo.field_time}</p>
                                </div>
                            </div>
                            <div className="profile__redes" id="redes-share" data-aos="fade-left" data-aos-duration="800" data-aos-anchor-placement="bottom-bottom">
                            </div>
                        </div>
                    </div>
                    <div className='detalle__content-body' data-aos='fade-up' dangerouslySetInnerHTML={{ __html: articleInfo.body }}></div>
                    <div className="detalle__content-description" data-aos='fade-up'>
                        <p className="textS tags">Tags: {articleInfo.tags.map((tag, index) => (
                            <a href="" key={index}>{tag}{articleInfo.tags.length != index + 1 && ', '}</a>
                        ))}</p>
                    </div>
                </div>
            </div>
        </div>

    )
}